import classNames from 'classnames';
import { bool, node, oneOfType, string } from 'prop-types';
import React from 'react';
import { Icon } from '@fiverr-private/fit';
import { r_chevron_down } from '@fiverr-private/fit/icons';

import styles from './index.module.scss';

const DropdownButton = ({ isOpen = false, disabled = false, label, outlined = false, className = '', iconClassName = '' }) => {
    const handleClick = (event) => {
        if (disabled) {
            event.stopPropagation();
        }
    };

    return (
        <div role="button"
            aria-label="Open Dropdown"
            onClick={handleClick}
            className={classNames(styles.button, className, 'flex', {
                'p-r-12 p-l-12 p-t-8 p-b-8 flex-between': outlined,
                [styles.outlined]: outlined,
                [styles.disabled]: disabled
            })}>
            {label && <span className="m-r-8">{label}</span>}
            <Icon size={12} className={classNames(styles.trigger, { [styles.open]: isOpen }, iconClassName)}>{r_chevron_down}</Icon>
        </div>
    );
};

DropdownButton.propTypes = {
    /**
     * Whether or not the dropdown is open
     */
    isOpen: bool,
    /**
     * Whether or not the dropdown is disabled
     */
    disabled: bool,
    /**
     * Trigger label
     */
    label: oneOfType([node, string]),
    /**
     * Whether or not the trigger should be outlined
     */
    outlined: bool,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: string,
    /**
     * Custom classes you wish to pass to the internal `<Icon/>` component.
     */
    iconClassName: string
};

export default DropdownButton;
